// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__WL0Yj","verify":"styles_verify__uC+Vk","okay":"styles_okay__Id2sS","close":"styles_close__OXa1B","verify-now":"styles_verify-now__ExNyE"};